import { DynamicFiltersInput } from '../../../../apis/graphql/reports/standardDelivery/types';
import { getCampaignIds } from '../../../../apis/graphql/reports/utils/utils';
import { StandardDeliveryReportFiltersInput, StandardDeliveryReportMetrics } from '../../../../apis/graphql/types';
import { CellStatus, CellWithMergedRows } from '../../../../components/BlueTheme/Table/types';
import { StorageCampaign } from '../../types/reports';
import { LINE_ITEM_NAME_COLUMN_ID } from '../constants';
import { StandardDeliveryReportTableData } from './types';

const UNKNOWN = 'Unknown';

export const prepareStandardDeliveryReportDataForTable = (
  standardDeliveryReports: StandardDeliveryReportMetrics[]
): StandardDeliveryReportTableData[] => {
  const preparedStandardDeliveryReports: StandardDeliveryReportTableData[] = [];

  standardDeliveryReports.forEach((report: StandardDeliveryReportMetrics) => {
    if (report.lineItems.length <= 0) {
      return;
    }

    if (report.lineItems.length === 1) {
      preparedStandardDeliveryReports.push({
        lineItemName: report.lineItemName,
        campaignName: report.campaignName ?? '',
        accountManager: report.accountManager ?? UNKNOWN,
        accountExecutive: report.accountExecutive ?? UNKNOWN,
        ...report.lineItems[0],
      });
    } else {
      report.lineItems.forEach((lineItem, index) => {
        const commonReportData: StandardDeliveryReportTableData = {
          lineItemName: report.lineItemName,
          campaignName: report.campaignName ?? '',
          accountManager: report.accountManager ?? UNKNOWN,
          accountExecutive: report.accountExecutive ?? UNKNOWN,
          ...report.lineItems[index],
        };

        const cellsWithMergedRows: CellWithMergedRows[] =
          index === 0
            ? getCellsWithMergedRows(report.lineItems.length, CellStatus.main)
            : getCellsWithMergedRows(report.lineItems.length, CellStatus.merged);

        preparedStandardDeliveryReports.push({
          ...commonReportData,
          cellMerges: cellsWithMergedRows,
        });
      });
    }
  });

  return preparedStandardDeliveryReports;
};

const getCellsWithMergedRows = (mergedCellsCount: number, status: CellStatus): CellWithMergedRows[] => {
  return [
    {
      cellId: LINE_ITEM_NAME_COLUMN_ID,
      mergedCellsCount,
      status,
    },
  ];
};

export const getStandardDeliveryReportFilters = (
  organizationId: string,
  dynamicFilters: DynamicFiltersInput,
  advertiserId: string,
  campaigns?: StorageCampaign[]
): StandardDeliveryReportFiltersInput => ({
  organizationId,
  advertiserId,
  campaignIds: getCampaignIds(campaigns),
  cpm: dynamicFilters.cpm || null,
  revenue: dynamicFilters.revenue || null,
  orderGoal: dynamicFilters.orderGoal || null,
  startDate: dynamicFilters.startDate || null,
  endDate: dynamicFilters.endDate || null,
  adProduct: dynamicFilters.adProduct || null,
});
